import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      menu: true,
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/about/index.vue"),
    meta: {
      menu: true,
    },
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/news/index.vue"),
    meta: {
      menu: true,
    },
  },
  {
    path: "/news/detail",
    name: "newsDetail",
    component: () => import("@/views/news/newsDetail/index.vue"),
    meta: {
      menu: false,
    },
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: () => import("@/views/contactUs/index.vue"),
    meta: {
      menu: true,
    },
  },
  {
    path: "/mall",
    name: "mall",
    redirect: "/mall/home",
    component: () => import("@/views/mall/index"),

    children: [
      {
        path: "home",
        name: "mallHome",
        component: () => import("@/views/mall/home/index.vue"),
        meta: {
          menu: true,
        },
      },
      {
        path: "/mall/shopCar",
        name: "shopCar",
        component: () => import("@/views/mall/ShopCar/index.vue"),
        meta: {
          menu: false,
        },
      },
      {
        path: "/mall/details",
        name: "details",
        component: () => import("@/views/mall/Details/index.vue"),
        meta: {
          menu: false,
        },
      },
      {
        path: "order",
        name: "order",
        component: () => import("@/views/mall/Order/index.vue"),
        meta: {
          menu: false,
        },
      },
      {
        path: "address",
        name: "address",
        component: () => import("@/views/mall/Address/index.vue"),
        meta: {
          menu: false,
        },
      },
      {
        path: "editAddr",
        name: "EditAddr",
        component: () => import("@/views/mall/EditAddr/index.vue"),
        meta: {
          menu: false,
        },
      },
      {
        path: "/postInformation",
        name: "postInformation",
        component: () => import("@/views/postInformation/index.vue"),
        meta: {
          menu: false,
        },
      },
      /*  
     
      {
        path: "center",
        name: "center",
        component: () => import("@/views/mall/center/index.vue"),
      },
      {
        path: "orderList",
        name: "orderList",
        component: () => import("@/views/mall/OrderList/index.vue"),
      },
      {
        path: "orderDetails",
        name: "orderDetails",
        component: () => import("@/views/mall/OrderDetails/index.vue"),
      },
      {
        path: "search",
        name: "search",
        component: () => import("@/views/mall/Search/index.vue"),
      },*/
    ],
  },
];
const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// router.beforeEach((to, from, next) => {});

export default router;
